const getters = {
  getDayStatsTotal: (state, getters, rootState) => {
    return _.toArray(state.dayStats);
  },

  getDayStatsOfUser: (state, getters, rootState) => (userId) => {
    return _.toArray(state.dayStats).filter(dayStat => dayStat.userId === userId && dayStat.didReset === false);
  }
}

export default getters
